export default {
  placeholder: '内容を入力してください',
  insertImage: '画像を挿入',
  insertVideo: '動画を挿入',
};
